<template>
  <Carousel :autoplay="5000" :wrap-around="true">
    <Slide :key="3">
      <div class=""><img src="@/assets/carousel-img/Frame3.png" class="d-block w-100"></div>
    </Slide>
    <Slide :key="4">
      <div class=""><img src="@/assets/carousel-img/Frame4.png" class="d-block w-100"></div>
    </Slide>
    <Slide :key="5">
      <div class=""><img src="@/assets/carousel-img/Frame5.png" class="d-block w-100"></div>
    </Slide>

    <template #addons>
      <navigation>
        <template #next>
          <font-awesome-icon icon="chevron-right" aria-hidden="true" style="color: #FEC93C;"></font-awesome-icon>
        </template>
        <template #prev>
          <font-awesome-icon icon="chevron-left" aria-hidden="true" style="color: #FEC93C;"></font-awesome-icon>
        </template>
      </navigation>
      <Pagination />
    </template>
  </Carousel>
</template>
  
<script>
import { defineComponent } from 'vue'
import { Carousel, Navigation, Pagination, Slide } from 'vue3-carousel'

import 'vue3-carousel/dist/carousel.css'

export default defineComponent({
  name: 'BasicComponent',
  components: {
    Carousel,
    Slide,
    Pagination,
    Navigation,
  },
})

</script>

<style>
:root {
  --vc-pgn-background-color: #feca3c79;
  --vc-pgn-active-color: #FEC93C;
  --vc-pgn-width: 30px;
  --vc-pgn-height: 10px;
}

.carousel__pagination-button {
  height: 50px;
}

.carousel__pagination {
  display: flex;
  margin: 0px 0 0;
  background-color: #79d0e3;
  padding: 0px 0px 0px 0px;
}
</style>